import Model from 'src/storage/list';

class MessagesFilesModel extends Model {
  id = 'MessagesFilesModel';
  persistent = false;
  listPersistent = false;
  apiConfig = {
    list: {
      url: 'message/files',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    refresh: {
      url: 'message/files',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true,
      event: 'messageRefresh'
    },
  };
  idKey= 'counter'

  listLimit = 30;

  _events = {
    openContact: 'onOpenContact',
    'foxsocket:message:msg': 'onMessage',
  };

  sortBy = {
    key: 'counter',
    desc: true
  };

  onOpenContact = ({contact}) => {
    let oldPartnerId = this.state.partnerId;
    let newPartnerId = contact.partnerId;
    this.setStateSilent({current: newPartnerId + ':recent', partnerId: newPartnerId, contact});
    if (oldPartnerId !== newPartnerId) this.refresh(newPartnerId + ':recent');
  };
  onMessage = ({channel, data}) => {
    let userId = this.userId;
    if (channel !== 'u-' + userId) return this.log('wrong channel');
    let {from, to, media} = data;
    if (!media || !media.length) return;
    let partnerId = userId === from ? to : from;
    let listId = partnerId + ':recent';

    let items = this.items(listId);
    media.forEach(m => {
      if (items.findIndex(i => i.counter === m.counter) < 0) {
        items.unshift(m);
      }
    })
  }

  listParams(loadMore) {
    const partnerId = this.state.partnerId;
    if (!partnerId) return null;

    let req = {
      partnerId,
      limit: this.listLimit,
      skip: 0
    };
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }
}

export default new MessagesFilesModel();
